// Cột "Thông báo" ở bảng bài đăng cộng đồng: push "Deal mới" đi đường nào, tới bao
// nhiêu người, trễ ở khâu nào. Dữ liệu = Posts.pushStats do backend ghi
// (services/community-post-push-stats.js). Bài đăng trước khi có tính năng → "—".
import React from "react";
import { Tag, Tooltip } from "antd";

const VIA_TAG = {
    topic: { color: "green", label: "⚡ Topic" },
    queue: { color: "orange", label: "Hàng đợi" },
    none: { color: "default", label: "Không ai theo dõi" },
};

const fmtSeconds = (ms) => (ms < 10000 ? `${(ms / 1000).toFixed(1)}s` : `${Math.round(ms / 1000)}s`);

function renderPushStats(stats, record) {
    if (!stats || !stats.via) return <span className="text-content-3">—</span>;

    const tag = stats.fallback ? { color: "red", label: "Topic hỏng → hàng đợi" } : VIA_TAG[stats.via] || VIA_TAG.queue;
    const tgToPost = stats.sourceAt && record.createTime ? record.createTime - stats.sourceAt : null;
    const postToPush = stats.sentAt && record.createTime ? stats.sentAt - record.createTime : null;

    const tip = (
        <div>
            {tgToPost !== null && <div>Telegram → bài: {fmtSeconds(tgToPost)} (nhận tin + gom album + tải ảnh)</div>}
            {postToPush !== null && (
                <div>
                    Bài → push rời server: {fmtSeconds(postToPush)}
                    {stats.via === "queue" && " — chỉ là lúc xếp hàng xong, người cuối hàng nhận chậm hơn nữa"}
                </div>
            )}
            <div>Sau đó là phần của Google/Apple (thường 1–3s).</div>
            {stats.topic && <div className="opacity-70">{stats.topic}</div>}
            {stats.repush && (
                <div className="mt-1">
                    ↻ Sửa tin đổi sang #{stats.repush.category} → gửi bù {stats.repush.followers} người
                    {record.createTime && ` (sau ${fmtSeconds(stats.repush.sentAt - record.createTime)})`}
                </div>
            )}
        </div>
    );

    return (
        <Tooltip title={tip}>
            <div className="text-xs leading-5 whitespace-nowrap">
                <Tag color={tag.color} className="mr-0">{tag.label}</Tag>
                {stats.via !== "none" && <div>👥 {stats.followers} người</div>}
                {stats.repush && (
                    <div className="text-blue-500">↻ bù {stats.repush.followers} người #{stats.repush.category}</div>
                )}
                {(tgToPost !== null || postToPush !== null) && (
                    <div className="text-content-3">
                        {tgToPost !== null && `TG→bài ${fmtSeconds(tgToPost)}`}
                        {tgToPost !== null && postToPush !== null && " · "}
                        {postToPush !== null && `→push ${fmtSeconds(postToPush)}`}
                    </div>
                )}
            </div>
        </Tooltip>
    );
}

export function pushStatsColumn() {
    return {
        title: "Thông báo",
        dataIndex: "pushStats",
        key: "pushStats",
        // Đủ cho "TG→bài 2.9s · →push 1.6s" nằm một dòng (whitespace-nowrap)
        width: 190,
        render: renderPushStats,
    };
}
